import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const YouTubeIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      d="M1.43321 47.3231C2.73988 51.9578 6.73721 52.8058 7.00388 52.9685C13.5825 54.7605 50.4572 54.7658 57.1346 52.9685C61.7079 51.6458 62.5479 47.5898 62.7052 47.3231C64.4466 38.0591 64.5612 25.9818 62.6252 15.4698L62.7052 15.9924C61.3986 11.3578 57.4012 10.5098 57.1346 10.3471C50.6439 8.58445 13.6732 8.51778 7.00388 10.3471C2.43055 11.6724 1.59055 15.7258 1.43321 15.9924C-0.430786 25.7285 -0.52412 36.8991 1.43321 47.3231ZM25.6625 41.3951V21.9471L42.3719 31.6858L25.6625 41.3951Z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </IconBox>
);

export default YouTubeIcon;
